import React from "react";
import Kandi from "../../Assets/Certificates/Kandi Certificate.jpg";
import Pafla from "../../Assets/Certificates/Pafla.jpeg";
import google from "../../Assets/Certificates/google.jpg";
import reactImage from "../../Assets/Certificates/React JS.jpg";
import mern from "../../Assets/Certificates/mern.jpg";
import aptech from "../../Assets/Certificates/aptech.jpg";
import techblade from "../../Assets/Certificates/Tech Blade.jpg";
import techwiz from "../../Assets/Certificates/Techwiz.jpg";
import marathon from "../../Assets/Certificates/Marathon.jpg";
import Coursera1 from "../../Assets/Certificates/Coursera-1.jpg";
import LazyImage from "../LazyLoading/LazyImage";

const cardData = [
  {
    id: 1,
    title: "Meta Introduction To Front End Development - Coursera",
    image: Coursera1,
  },
  {
    id: 2,
    title: "Pafla - Pakistan Freelancers Association",
    image: Pafla,
  },
  {
    id: 3,
    title: "Fundamentals Of Digital Marketing - GDG",
    image: google,
  },
  {
    id: 4,
    title: "React JS For Beginners- Simplilearn",
    image: reactImage,
  },
  {
    id: 5,
    title: "Html And CSS - OpenWeiver",
    image: Kandi,
  },
  {
    id: 6,
    title: "MERN App Development - Jawan Pakistan",
    image: mern,
  },
  {
    id: 7,
    title: "DISM - Aptech",
    image: aptech,
  },
  {
    id: 8,
    title: "Certificate Of Appreciation - GDSC IU",
    image: techblade,
  },
  {
    id: 9,
    title: "CK Marathon 4 - Commission Karachi",
    image: marathon,
  },
  {
    id: 10,
    title: "Participation In Techwiz - Aptech",
    image: techwiz,
  },
];

const CertificatePage = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-lg-3" key={index}>
              <div className="card shadow-box-2 bg-dark">
                <LazyImage
                  src={card.image}
                  alt="Lazy-loaded Image"
                  className="card-img-top"
                />
                {/* <img src={card.image} alt="..." /> */}
                <div className="card-body">
                  <h6 className="card-title">{card.title}</h6>
                  <p className="card-text">{card.desc}</p>
                  {/* <a href="#" className="btn btn-primary">
                    Go somewhere
                  </a> */}
                </div>
              </div>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;
